import { css } from '@emotion/core';

export default ({ classes }) => css`
  ${classes && classes.structure
    ? classes.structure.padding.space.right[1]
    : 'padding-right: 0.4rem;'}
  & > span:last-child {
    ${classes && classes.structure
      ? classes.structure.padding.space.left[1]
      : 'padding-left: 0.4rem;'}
  }
`;
